import React, { useEffect, useState } from 'react';
import * as Styled from './styled';
import * as XLSX from 'xlsx';
import uuid from 'react-uuid';
import axios from 'axios';

const baseURL = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/add-multiple-questions`;
const payloadLimit = 1000;

const ImportQuestion = () => {
    const [allSheetData, setAllSheetData] = useState({});
    const [currSheet, setCurrSheet] = useState('');
    const [maxLenObj, setmaxLenObj] = useState(null);
    const [maxLen, setMaxLen] = useState(0);
    const [error, setError] = useState('');
    const [submitSheetSuccess, setSubmitSheetSuccess] = useState('');

    useEffect(() => {
        resetFile();
    }, []);

    const excelFileHandler = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const extension = file.name.split('.')[1];
        if (extension !== 'xlsx') {
            setError('Please upload .xlsx File!');
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const workbook = XLSX.read(reader.result, {
                type: "binary"
            });
            const data = {};
            workbook.SheetNames.forEach((sheetName) => {
                const rowObj = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                data[sheetName] = rowObj;
            });
            setAllSheetData(data);
        }
        reader.readAsBinaryString(file);
    }

    const handleSheet = (e) => {
        setCurrSheet(e.target.innerText);
        fillEmptySheet(e.target.innerText);
        setSubmitSheetSuccess('');
    }

    const fillEmptySheet = (sheetName) => {
        let maxLen = 0;
        let maxLenRow;
        allSheetData[sheetName].forEach((obj) => {
            if (Object.keys(obj).length > maxLen) {
                maxLen = Object.keys(obj).length;
                maxLenRow = obj;
            }
        });
        setmaxLenObj(maxLenRow);
        setMaxLen(maxLen);
    }

    const returnTR = (obj) => {
        const arr = [];
        const keys = Object.keys(obj);
        for (let i = 0; i < Object.keys(obj).length; i++) {
            arr.push(
                <td key={uuid()}>
                    {
                        obj[keys[i]] === 'error' ? <Styled.ErrorDiv>{'Data needs to be entered!'}</Styled.ErrorDiv>
                            : <div>{obj[keys[i]]}</div>
                    }
                </td>
            );
        }
        for (let i = 0; i < (maxLen - Object.keys(obj).length); i++) {
            arr.push(<td key={uuid()}>
                    <div>{'blank'}</div>
                </td>);
        }
        return <tr key={uuid()}>
            { arr }
        </tr>
    }

    const resetFile = () => {
        setError('');
        setSubmitSheetSuccess('');
        setAllSheetData({});
        setCurrSheet('');
        setmaxLenObj(null);
        setMaxLen(0);
    }

    const sendRequest = (arr) => {
        const postData = {
            "questions_list": arr
        }
        console.log(JSON.stringify(postData));
        axios({
            headers: {
                authorization: localStorage.getItem("jwtToken"),
                'Content-Type': 'application/json'
              },
            method: 'POST',
            url: baseURL,
            data: JSON.stringify(postData)
        }).then((response) => {
            console.log(response);
            setSubmitSheetSuccess('Sheet uploaded successfully');
        }).catch((err) => {
            console.log(err);
            if (err?.response?.status == 400) {
                setSubmitSheetSuccess('Please add skill from Master Skills List Only!');
            } else {
                setSubmitSheetSuccess('There was error while submiting the sheet!');
            }
        })
    }
    

    const uploadSheet = () => {
        setSubmitSheetSuccess("Please wait sheet data is being processed!");
        const dataToBeUploaded = [];

        if (currSheet.toLowerCase().indexOf('mcq') > -1) {
            allSheetData[currSheet].forEach(obj => {
                const dataToPush = {
                    question_title: '',
                    category_name: '',
                    topic_name: '',
                    difficulty_level: '',
                    question_type_code: 'MCQ',
                    question_details: '',
                    question_data: {
                        "options": [],
                        "correct_answer": []
                    }
                }
                let optionsIdx = 0;
                Object.keys(obj).forEach(fieldName => {
                    const tempFieldName = fieldName.toLowerCase();

                    if (tempFieldName.includes('topic')) {
                        dataToPush.topic_name = obj[fieldName].toUpperCase().trim();

                    } else if (tempFieldName.includes('title')) {
                        dataToPush.question_title = obj[fieldName];

                    } else if (tempFieldName.includes('category')) {
                        dataToPush.category_name = obj[fieldName].toUpperCase().trim();

                    } else if (tempFieldName.includes('difficulty')) {
                        dataToPush.difficulty_level = obj[fieldName].toUpperCase().trim();

                    } else if (tempFieldName.includes('question details')) {
                        dataToPush.question_details = obj[fieldName];

                    } else if (tempFieldName.includes('option')) {
                        dataToPush["question_data"]["options"].push({
                            index: optionsIdx,
                            option: obj[fieldName].toString()
                        })
                        optionsIdx += 1;
                    } else if (tempFieldName.includes('answer')) {
                        obj[fieldName] += '';
                        dataToPush["question_data"]["correct_answer"] = obj[fieldName].split(',').map(ans => parseInt(ans) - 1)
                    }
                });
                dataToBeUploaded.push(dataToPush);
            });
        
        } else if (currSheet.toLowerCase().indexOf('coding') > -1) {
            allSheetData[currSheet].forEach(obj => {
                const dataToPush = {
                    question_title: '',
                    category_name: '',
                    topic_name: '',
                    difficulty_level: '',
                    question_type_code: 'COMPILER',
                    question_details: '',
                    question_data: []
                }
                const codingDataObj = {
                    std_input: '',
                    std_output: ''
                };

                let visibility;
                if (Object.keys(obj).includes('visibility')) {
                    visibility = 'visibility'
                } else if (Object.keys(obj).includes('Visibility')) {
                    visibility = 'Visibility'
                }

                Object.keys(obj).forEach(fieldName => {
                    const tempFieldName = fieldName.toLowerCase();

                    if (tempFieldName.includes('title')) {
                        dataToPush.question_title = obj[fieldName];

                    } else if (tempFieldName.includes('topic')) {
                        dataToPush.topic_name = obj[fieldName].toUpperCase().trim();
                        
                    } else if (tempFieldName.includes('category')) {
                        dataToPush.category_name = obj[fieldName].toUpperCase().trim();
                        
                    } else if (tempFieldName.includes('question details')) {
                        dataToPush.question_details = obj[fieldName];
                    
                    } else if (tempFieldName.includes('difficulty')) {
                        dataToPush.difficulty_level = obj[fieldName].toUpperCase().trim();

                    } else if (tempFieldName.includes('input')) {
                        codingDataObj['std_input'] = obj[fieldName].toString();

                    } else if (tempFieldName.includes('output')) {
                        codingDataObj['std_output'] = obj[fieldName].toString();
                    }

                    if (codingDataObj['std_input'] !== '' && codingDataObj['std_output'] !== '') {
                        dataToPush["question_data"].push({
                            "std_input": codingDataObj['std_input'],
                            "std_output": codingDataObj['std_output'],
                            "visibility": (obj[visibility].toUpperCase() || "PUBLIC")
                        });
                        codingDataObj['std_input'] = '';
                        codingDataObj['std_output'] = '';
                        
                    }
                });
                dataToBeUploaded.push(dataToPush);
            });

        } else {
            setError('Please provide a valid sheet name!');
        }
        while (dataToBeUploaded.length > 0) {
            sendRequest(dataToBeUploaded.splice(0, payloadLimit));
        }
    }

    return <Styled.MainDiv>
        <h1>Please Upload Excel File for Question</h1>
        <Styled.LabelWrap>
            <Styled.ImportLabel>
                Add Questions File
                <Styled.ImportInput
                    type = "file"
                    onChange={excelFileHandler}
                />
            </Styled.ImportLabel>
            <Styled.RemoveButton onClick={resetFile}>{'Remove File'}</Styled.RemoveButton>
        </Styled.LabelWrap>
        {
            error && 
                <Styled.FileError>{error}</Styled.FileError>
        }
        {
            Object.keys(allSheetData).length > 0 && <h2>Select the sheet you want to view</h2>
        }
        <Styled.ButtonWrap>
            {
                Object.keys(allSheetData).map(sheetName => {
                    return (
                        <Styled.Button key={uuid()} onClick={(e) => handleSheet(e)}>{sheetName}</Styled.Button>
                    )
                })
            }
        </Styled.ButtonWrap>
        {
            currSheet && 
                <div>
                    <div style={{ display: "flex", alignItems: "center", marginTop: "20px" }}>
                    <Styled.SubmitButton onClick={uploadSheet}>{'Submit Sheet'}</Styled.SubmitButton>
                    {
                        submitSheetSuccess &&
                            <Styled.SubmitSheetError>{submitSheetSuccess}</Styled.SubmitSheetError>
                    }
                    </div>
                    <Styled.Table>
                    <thead>
                        <tr>
                            {
                                Object.keys(maxLenObj).map(fieldName => {
                                        return <th key={uuid()}>
                                            <div>{fieldName}</div> 
                                        </th>
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                    {
                        allSheetData[currSheet].map(obj => (
                            returnTR(obj)
                        ))
                    }
                    </tbody>
                    </Styled.Table>
                </div>
        }

    </Styled.MainDiv>
}

export default ImportQuestion;